import React, { useEffect, useRef, useState } from "react";
import Loadable from "react-loadable";
import { ConfigProvider, Result } from "antd";
import zhCN from "antd/lib/locale-provider/zh_CN";
import CustomSpin from "./misc/CustomSpin";
import "./App.css";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { getTokenFromLocalCache, isCidaPartnerAdmin } from "./misc/Utils";
import { EnumAppStatus } from "./misc/Config";
import AdminModel from "./model/Admin.model";
import { adminProfileRequest } from "./misc/ServerInterface";
import { AppContext } from "./misc/Context";
import AdminLayout from "./views/AdminLayout/AdminLayout";
import { Helmet } from "react-helmet";

const Login = Loadable({
    loader: () => import('./views/Login/Login'),
    loading: CustomSpin,
});

function AppContent() {
    const [appStatus, setAppStatus] = useState<EnumAppStatus>(EnumAppStatus.Pending);
    const [admin, setAdmin] = useState<AdminModel | undefined>();
    const [breadcrumb, setBreadcrumb] = useState<string>("");

    useEffect(() => {
        async function fetch() {
            const r = await adminProfileRequest();
            if (!r) {
                setAppStatus(EnumAppStatus.Error);
                return;
            }
            setAdmin(AdminModel.modelWithServerData(r.data));
            setAppStatus(EnumAppStatus.Success);
        }

        fetch();
    }, []);

    switch (appStatus) {
        case EnumAppStatus.Pending:
            return <CustomSpin/>;
        case EnumAppStatus.Success:
            return <AppContext.Provider value={ { admin: admin!, breadcrumb, setBreadcrumb } }>
                <AdminLayout/>
            </AppContext.Provider>;
        case EnumAppStatus.Error:
            return <Result
                status="error"
                title="Application Init Fail"
            />
    }
}

export default function () {
    const logined = useRef<boolean>(Boolean(getTokenFromLocalCache()));

    return <ConfigProvider locale={ zhCN }>
        {
            isCidaPartnerAdmin() ? <Helmet>
                    <title>中国室内装饰协会-合作机构管理系统</title>
                    <link rel="shortcut icon" href="https://cdn.cecctm.com/news/cida_favicon.ico"/>
                </Helmet> :
                <Helmet>
                    <title>综合人才测评-合作机构管理系统</title>
                    <link rel="shortcut icon" href="https://cecctm.oss-cn-hangzhou.aliyuncs.com/news/gxhb_logo.ico"/>
                </Helmet>
        }

        <BrowserRouter>
            <Switch>
                <Route exact path="/login" component={ Login }/>
                <Route path="/" render={ _ => logined.current ?
                    <AppContent/> :
                    <Redirect to={ { pathname: "/login" } }/> }
                />
            </Switch>
        </BrowserRouter>
    </ConfigProvider>
}
